import {
    INITIALIZE_HALL,
    INITIALIZE_HALL_WITH_SEATS,
    SET_SECTORS,
    SET_SECTOR_WITH_SEATS,
    SET_SEATS_PURCHASE_STATUS,
    ADJUST_GENERAL_ADMISSIONS_USED_SEATS_COUNT,
    SET_GENERAL_ADMISSIONS_USED_SEATS_COUNT,
    SET_RESERVATION_SEAT_AS_AVAILABLE,
    SET_GENERAL_ADMISSIONS_PURCHASE_STATUS,
    DELETE_SEATING_RESERVATION,
    COMPILE_OBJECTS_CACHE_KEY,
    UNASSIGN_TICKET_TYPE_FROM_SEATINGS,
    DELETE_TICKET_TYPE,
} from '../actionTypes';

import handleInitializeHallWithSeats from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/handleInitializeHall';
import handleInitializeHall from './handleInitializeHall';
import handleSetSectorWithSeats from './handleSetSectorWithSeats';
import handleSetSeatsPurchaseStatus from './handleSetSeatsPurchaseStatus';
import handleAdjustGeneralAdmissionsUsedSeatsCount from './handleAdjustGeneralAdmissionsUsedSeatsCount';
import handleSetGeneralAdmissionsUsedSeatsCount from './handleSetGeneralAdmissionsUsedSeatsCount';
import handleSetReservationSeatAsAvailable from './handleSetReservationSeatAsAvailable';
import handleDeleteSeatingReservation from './handleDeleteSeatingReservation';
import handleSetGeneralAdmissionsPurchaseStatus from './handleSetGeneralAdmissionsPurchaseStatus';
import handleCompileObjectsCacheKey from './handleCompileObjectsCacheKey';
import handleDeleteTicketType from './handleDeleteTicketType';
import handleUnassignTicketTypeFromSeatings from './handleUnassignTicketTypeFromSeatings';
import handleSetSectors from './handleSetSectors';

function reducers(session, action) {
    if (action.type === INITIALIZE_HALL) {
        handleInitializeHall(session, action);
    } else if (action.type === INITIALIZE_HALL_WITH_SEATS) {
        handleInitializeHallWithSeats(session, action);
    } else if (action.type === SET_SECTORS) {
        handleSetSectors(session, action);
    } else if (action.type === SET_SECTOR_WITH_SEATS) {
        handleSetSectorWithSeats(session, action);
    }
    if (action.type === SET_SEATS_PURCHASE_STATUS) {
        handleSetSeatsPurchaseStatus(session, action);
    }
    if (action.type === ADJUST_GENERAL_ADMISSIONS_USED_SEATS_COUNT) {
        handleAdjustGeneralAdmissionsUsedSeatsCount(session, action);
    }
    if (action.type === SET_GENERAL_ADMISSIONS_USED_SEATS_COUNT) {
        handleSetGeneralAdmissionsUsedSeatsCount(session, action);
    }
    if (action.type === SET_RESERVATION_SEAT_AS_AVAILABLE) {
        handleSetReservationSeatAsAvailable(session, action);
    }
    if (action.type === SET_GENERAL_ADMISSIONS_PURCHASE_STATUS) {
        handleSetGeneralAdmissionsPurchaseStatus(session, action);
    }
    if (action.type === DELETE_SEATING_RESERVATION) {
        handleDeleteSeatingReservation(session, action);
    }
    if (action.type === COMPILE_OBJECTS_CACHE_KEY) {
        handleCompileObjectsCacheKey(session, action);
    }
    if (action.type === UNASSIGN_TICKET_TYPE_FROM_SEATINGS) {
        handleUnassignTicketTypeFromSeatings(session, action);
    }
    if (action.type === DELETE_TICKET_TYPE) {
        handleDeleteTicketType(session, action);
    }

    return session.state;
}

export default reducers;
